/**
 * Live header cart count.
 *
 * The cart badges (.agata-cart-count on desktop, .mobile-cart-count on mobile)
 * are rendered by Liquid from cart.item_count, so without this they only change
 * on a full page reload. This keeps them in sync the moment the cart changes -
 * add to cart, quantity +/- in the drawer, remove, or clear - with a small pop.
 */
(function () {
  "use strict";
  if (window.__marbilyCartCountLive) return;
  window.__marbilyCartCountLive = true;

  function paint(link, spanClass, count) {
    if (!link) return;
    var span = link.querySelector("." + spanClass);
    if (count > 0) {
      if (!span) {
        span = document.createElement("span");
        span.className = spanClass;
        link.appendChild(span);
      }
      if (span.textContent !== String(count)) {
        span.textContent = count;
        // restart the pop animation
        span.classList.remove("cart-count--bump");
        void span.offsetWidth;
        span.classList.add("cart-count--bump");
      }
    } else if (span) {
      span.remove();
    }
  }

  function render(count) {
    paint(document.querySelector('a.agata-util[href*="cart"]'), "agata-cart-count", count);
    paint(document.querySelector("a.mobile-cart"), "mobile-cart-count", count);
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.item_count); })
      .catch(function () {})
      .finally(function () { pending = false; });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\b)/;

  // Catch cart mutations regardless of how the theme performs them.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var u = typeof url === "string" ? url : (url && url.url) || "";
    var p = origFetch.apply(this, arguments);
    if (CART_MUTATION.test(u)) p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartUrl = url || "";
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (CART_MUTATION.test(this.__cartUrl || "")) {
      this.addEventListener("loadend", function () { setTimeout(refresh, 60); });
    }
    return origSend.apply(this, arguments);
  };

  // The theme also broadcasts these when the cart changes.
  ["cart-drawer:refresh", "cart:refresh", "cart:updated"].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(refresh, 60); });
  });
})();
